var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(-321 -594)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon_auto-detect",
    "data-name": "icon/auto-detect",
    width: 24,
    height: 24,
    transform: "translate(321 594)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M9.351,0A9.351,9.351,0,1,1,0,9.351,9.351,9.351,0,0,1,9.351,0Z",
    transform: "translate(323.78 596.649)",
    fill: "none",
    stroke: "#c1a700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.636,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,0V3.6",
    transform: "translate(333.13 595.211)",
    fill: "none",
    stroke: "#c1a700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.636
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M3.6,0H0",
    transform: "translate(340.323 606)",
    fill: "none",
    stroke: "#c1a700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.636
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_7",
    "data-name": "Stroke 7",
    d: "M0,3.6V0",
    transform: "translate(333.13 613.193)",
    fill: "none",
    stroke: "#c1a700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.636
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_9",
    "data-name": "Stroke 9",
    d: "M0,0H3.6",
    transform: "translate(322.341 606)",
    fill: "none",
    stroke: "#c1a700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.636
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_11",
    "data-name": "Stroke 11",
    d: "M2.158,0A2.158,2.158,0,1,1,0,2.158,2.158,2.158,0,0,1,2.158,0Z",
    transform: "translate(330.972 603.842)",
    fill: "none",
    stroke: "#c1a700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.636,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPointer);
export default __webpack_public_path__ + "static/media/location_pointer.a32fae0b684207afd24f22d2bf239b5a.svg";
export { ForwardRef as ReactComponent };